/**
 * Behandelstatus van een AI-chatconversatie. De waarden zijn de Java-constantennamen, want de backend
 * resolvet de filterparameter met `Enum.valueOf`.
 */
export enum AIChatConversatieStatus {
	NIEUW = 'NIEUW',
	IN_BEHANDELING = 'IN_BEHANDELING',
	VERWERKT = 'VERWERKT',
}

/** Vertaalt de status enum naar de naam die de gebruiker kent. */
export function getAIChatConversatieStatusName(status: AIChatConversatieStatus): string {
	switch (status) {
		case AIChatConversatieStatus.NIEUW:
			return 'Nieuw';
		case AIChatConversatieStatus.IN_BEHANDELING:
			return 'In behandeling';
		case AIChatConversatieStatus.VERWERKT:
			return 'Verwerkt';
		default:
			return '';
	}
}
